import gettext from '@sdk/lang/gettext';

export function getNoPagesText(canCreatePages: boolean) {
  const textFirstLine = canCreatePages
    ? gettext('Looks like you have no pages yet.')
    : gettext('No content shared yet.');
  const textSecondLine = canCreatePages
    ? gettext('Create pages for your newsfeed to share updates with your team.')
    : gettext('Enjoy your day and check back later.');

  return { textFirstLine, textSecondLine };
}
